<template>
  <div>
    <Spin fix v-if="tableLoading"></Spin>
    <form-info :title="'防疫物资'" class="mb-1">
      <div slot="btn">
        <Button v-if="!isEdit" class="bkcc-btn btn" @click="edit">编辑</Button>
        <Button v-else class="bkcc-btn btn" @click="save">保存</Button>
      </div>
      <section v-if="isEdit" slot="content">
        <Row :gutter="20">
          <template v-for="(item,i) in form">
            <Col span="6" class="col">
              <div class="label">{{item.name}}</div>
              <div class="input-box">
                <Input type="number" v-model="searchForm[item.key]" placeholder="请输入数量" />
                <div class="unit">{{item.unit}}</div>
              </div>
            </Col>
          </template>
        </Row>
      </section>
      <section v-else="!isEdit" slot="content">
        <Row :gutter="20">
          <template v-for="(item,i) in form">
            <Col span="6" class="col">
              <div class="title">
                {{item.name}}
                <span class="unit">{{searchForm[item.key]}}{{item.unit}}</span>
              </div>
            </Col>
          </template>
        </Row>
      </section>
    </form-info>

    <form-info :title="'消杀记录'">
      <div slot="btn">
        <Button class="bkcc-btn" @click="add">新增</Button>
      </div>
      <section slot="content">
        <Table
          border
          stripe
          :columns="settingColumn"
          :data="tableData"
          :loading="tableLoading"
          class="table"
        ></Table>
        <!-- 分页 -->
        <Page
          v-show="total>0"
          class="page-wrap"
          show-total
          :total="total"
          :page-size="pageSize"
          @on-change="onPageChange"
        ></Page>
      </section>
    </form-info>
    <Modal v-model="isAdd" :title="'新增'" width="600">
      <div class="modal">
        <div class="input-box">
          <div class="mTitle">当前日期</div>
          <div style="width:100%">{{$util.FormatDate(date,"yyyy-MM-dd")}}</div>
        </div>
        <div class="input-box">
          <div class="mTitle">消毒人员</div>
          <Input v-model="userName" placeholder="请输入姓名" />
        </div>
      </div>
      <div slot="footer">
        <Button type="text" @click="isAdd=false">取消</Button>
        <Button type="primary" @click="addRecord">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import formInfo from "./formInfo";
export default {
  name: "qyEpidemic",
  components: { formInfo },
  props: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0, // 总数据量
      id: null,
      userName: "",
      date: new Date(),
      isEdit: false,
      isAdd: false,
      searchForm: {
        mask: "",
        disinfectant: "",
        alcohol: "",
        glove: "",
        temperatureGun: ""
      },
      form: [
        { name: "口罩", unit: "个", key: "mask" },
        { name: "84消毒液", unit: "升", key: "disinfectant" },
        { name: "酒精", unit: "升", key: "alcohol" },
        { name: "手套", unit: "双", key: "glove" },
        { name: "额温枪", unit: "把", key: "temperatureGun" }
      ],
      tableLoading: false,
      tableData: [],
      settingColumn: [
        {
          title: "日期",
          key: "date",
          minWidth: 200
        },
        {
          title: "时间",
          key: "time",
          minWidth: 200
        },
        {
          title: "消毒人员",
          key: "userName",
          minWidth: 200
        }
      ]
    };
  },
  computed: {},
  methods: {
    getSupplies() {
      let url = this.urlobj.getSupplies;
      let data = { companyId: this.$route.query.companyId };
      this.tableLoading = true;
      this.$post(url, data).then(res => {
        let data = res && res.rows[0];
        this.searchForm.mask = data && data.mask;
        this.searchForm.glove = data && data.glove;
        this.searchForm.disinfectant = data && data.disinfectant;
        this.searchForm.alcohol = data && data.alcohol;
        this.searchForm.temperatureGun = data && data.temperatureGun;
        this.id = data && data.id;
        this.tableLoading = false;
      });
    },
    edit() {
      this.isEdit = true;
    },
    add() {
      this.isAdd = true;
    },
    save() {
      let url = this.urlobj.addSupplies;
      let {
        mask,
        disinfectant,
        alcohol,
        glove,
        temperatureGun
      } = this.searchForm;
      if (!glove || !mask || !disinfectant || !alcohol || !temperatureGun) {
        return this.$Message.error("请填写完整防疫物资");
      }
      if (
        mask.toString().indexOf(".") != -1 ||
        glove.toString().indexOf(".") != -1 ||
        temperatureGun.toString().indexOf(".") != -1
      ) {
        return this.$Message.error("口罩,手套,额温枪请填写整数");
      }
      let data = {
        mask,
        disinfectant,
        alcohol,
        glove,
        temperatureGun,
        companyId: this.$route.query.companyId,
        id: this.id
      };
      console.log(data);
      this.tableLoading = true;
      this.$post(url, data).then(res => {
        console.log(res);
        this.isEdit = false;
        this.tableLoading = false;
      });
    },
    addRecord() {
      let url = this.urlobj.addSterilzatioin;
      if (this.userName == "") {
        return this.$Message.error("姓名不能为空");
      }
      let data = {
        companyId: this.$route.query.companyId,
        userName: this.userName
      };
      this.tableLoading = true;
      this.$post(url, data).then(res => {
        if (res && res.newPrimaryKeys.id) {
          this.isAdd = false;
          this.tableLoading = false;
          this.getRecord();
        }
      });
    },
    getRecord() {
      let url = this.urlobj.getSterilzatioin;
      let data = {
        companyId: this.$route.query.companyId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.tableLoading = true;
      this.$post(url, data).then(res => {
        let data = res && res.rows;
        this.total = res.total;
        this.tableLoading = false;
        this.tableData = data.map(item => {
          return {
            date: item.createTime.slice(0, 10),
            time: item.createTime.slice(-10, -5),
            userName: item.userName
          };
        });
      });
    },
    onPageChange(page) {
      this.pageNum = page;
      this.getRecord();
    }
  },
  created() {
    this.getSupplies();
    this.getRecord();
  }
};
</script>
<style lang="less" scoped>
.col {
  margin-bottom: 10px;
}
.mb-1 {
  margin-bottom: 20px;
}
.input-box {
  display: flex;
  align-items: center;
  margin: 5px 5px 5px 0;
}
.unit {
  font-weight: normal;
  margin-left: 5px;
}
.label {
  font-weight: bold;
}
.title {
  font-weight: bold;
}
.table {
  margin-top: 15px;
}
.mTitle {
  width: 80px;
}
.modal {
  height: 250px;
}
.page-wrap {
  text-align: center;
  margin-top: 50px;
}
</style>
